import { ImagesGetOrderByCreationTimeEnum, ImagesGetRequest } from '@nativewaves/nw-cloud-sdk/content'
import { createRoute } from '@tanstack/react-router'
import { t } from 'i18next'

import { StaticRouteParameter } from 'config/routing'
import { Overview } from 'domains/Workspaces/Images'
import { workspaceRoute } from 'pages/NWPlatform/Workspaces/Workspace/Routing'

import { Structure } from './Structure'

export const imagesRoute = createRoute({
  getParentRoute: () => workspaceRoute,
  path: StaticRouteParameter.IMAGES,
  loader: () => ({
    crumb: t('entity:content.image', { count: 2 }),
  }),
})

export const imagesOverviewLayoutRoute = createRoute({
  getParentRoute: () => imagesRoute,
  id: 'imagesOverviewLayout',
  component: Structure,
})

const sortProperties = ['orderByCreationTime'] as const satisfies (keyof PickStartsWith<ImagesGetRequest, 'orderBy'>)[]

const sortPropertyValues = new Map<keyof PickStartsWith<ImagesGetRequest, 'orderBy'>, Record<string, string>>([
  ['orderByCreationTime', ImagesGetOrderByCreationTimeEnum],
])

type ImagesOverviewSearch = Pick<ImagesGetRequest, 'groups' | 'excludeGrouped' | 'query'> &
  Partial<PickStartsWith<ImagesGetRequest, 'orderBy'>>

export const imagesOverviewRoute = createRoute({
  getParentRoute: () => imagesOverviewLayoutRoute,
  path: '/',
  component: Overview,
  validateSearch: (search: Record<string, unknown>): ImagesOverviewSearch => {
    const result: Record<string, unknown> = {}

    if (search.query && typeof search.query === 'string' && !!search.query.length) {
      result.query = search.query
    }

    if (search.groups && typeof search.groups === 'string' && !!search.groups.length) {
      result.groups = search.groups
    }

    if (search.excludeGrouped && typeof search.excludeGrouped === 'string' && !!search.excludeGrouped.length) {
      result.excludeGrouped = search.excludeGrouped
    }

    for (const sortProperty of sortProperties) {
      if (
        search[sortProperty] &&
        typeof search[sortProperty] === 'string' &&
        search[sortProperty] in sortPropertyValues.get(sortProperty)!
      ) {
        result[sortProperty] = search[sortProperty]
      }
    }

    return result satisfies ImagesOverviewSearch
  },
})
